'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _isNil = require('coact-utils/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toString(value) {
  return (0, _isNil2.default)(value) ? '' : '' + value;
}

function formatValue(_ref) {
  var value = _ref.value,
      _ref$formatter = _ref.formatter,
      formatter = _ref$formatter === undefined ? toString : _ref$formatter;

  var valueAsString = formatter(value);

  console.assert(typeof valueAsString === 'string', 'value should be mapped to string in Input, ' + formatter.name + '(', value, ') return', valueAsString);

  return valueAsString;
}

var any = _propTypes2.default.any,
    func = _propTypes2.default.func;

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  formatter: func
}), (0, _injectProps2.default)({
  value: any
}), (0, _exposeProps2.default)(function (props) {
  return {
    value: formatValue(props)
  };
}));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'formatValue');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/formatValue.js
// module id = 1677
// module chunks = 0